 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPS00COVER from '@/components/OEBPS/00cover'
 import OEBPS01HALFTITLE from '@/components/OEBPS/01halftitle'
 import OEBPS02TITLE from '@/components/OEBPS/02title'
 import OEBPS03COPYRIGHT from '@/components/OEBPS/03copyright'
 import OEBPS04DED from '@/components/OEBPS/04ded'
 import OEBPS05CONTENT from '@/components/OEBPS/05content'
 import OEBPS06PROLOGUE from '@/components/OEBPS/06prologue'
 import OEBPS07INTRO from '@/components/OEBPS/07intro'
 import OEBPSCH01 from '@/components/OEBPS/ch01'
 import OEBPSCH02 from '@/components/OEBPS/ch02'
 import OEBPSCH03 from '@/components/OEBPS/ch03'
 import OEBPSCH04 from '@/components/OEBPS/ch04'
 import OEBPSCH05 from '@/components/OEBPS/ch05'
 import OEBPSCH06 from '@/components/OEBPS/ch06'
 import OEBPSCH07 from '@/components/OEBPS/ch07'
 import OEBPSCH08 from '@/components/OEBPS/ch08'
 import OEBPSCH09 from '@/components/OEBPS/ch09'
 import OEBPSEPILOG from '@/components/OEBPS/epilog'
 import OEBPSNOTES from '@/components/OEBPS/notes'
 import OEBPSBIB from '@/components/OEBPS/bib'
 import OEBPSACK from '@/components/OEBPS/ack'
 import OEBPSINDEX from '@/components/OEBPS/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/00cover",
 			"name" : "OEBPS/00cover",
 			"component" : OEBPS00COVER
 		},
 		{
 			"path" : "/OEBPS/01halftitle",
 			"name" : "OEBPS/01halftitle",
 			"component" : OEBPS01HALFTITLE
 		},
 		{
 			"path" : "/OEBPS/02title",
 			"name" : "OEBPS/02title",
 			"component" : OEBPS02TITLE
 		},
 		{
 			"path" : "/OEBPS/03copyright",
 			"name" : "OEBPS/03copyright",
 			"component" : OEBPS03COPYRIGHT
 		},
 		{
 			"path" : "/OEBPS/04ded",
 			"name" : "OEBPS/04ded",
 			"component" : OEBPS04DED
 		},
 		{
 			"path" : "/OEBPS/05content",
 			"name" : "OEBPS/05content",
 			"component" : OEBPS05CONTENT
 		},
 		{
 			"path" : "/OEBPS/06prologue",
 			"name" : "OEBPS/06prologue",
 			"component" : OEBPS06PROLOGUE
 		},
 		{
 			"path" : "/OEBPS/07intro",
 			"name" : "OEBPS/07intro",
 			"component" : OEBPS07INTRO
 		},
 		{
 			"path" : "/OEBPS/ch01",
 			"name" : "OEBPS/ch01",
 			"component" : OEBPSCH01
 		},
 		{
 			"path" : "/OEBPS/ch02",
 			"name" : "OEBPS/ch02",
 			"component" : OEBPSCH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js